angular
  .module('fg')
  .factory('fgAttachDocumentFileListService', [
    '$q',
    'lodashService',
    fgAttachDocumentFileListService
  ]);

function fgAttachDocumentFileListService($q, lodashService) {
  // A list of all the file controls
  // These are identified by a combination of the fieldId AND the nodeId
  // This is because the fieldId is unique only within a flow Model NOT across flow instances.
  var _fileControls = [];
  var _form = undefined;

  var service = {
    files: [],
    addFile: addFile,
    getFilesForControl: getFilesForControl,
    clearFiles: clearFiles,
    removeFile: removeFile,
    isFileRequired: isFileRequired,
    registerFileControl: registerFileControl,
    removeAllFileControls: removeAllFileControls,
    storeForm: storeForm
  };

  return service;

  //////////// Public API Methods
  function addFile(file, fieldId, nodeId) {
    var fileList = getFileControl(fieldId, nodeId);

    if (fileList) {
      fileList.isDirty = true;
      //dont add file if it already exists
      var index = fileList.files.findIndex(function (f) {
        return f.id === file.id;
      });
      if (index < 0) {
        fileList.files.push(file);
      }
    }
  }

  // CLear all files associated with the provided fieldId
  function clearFiles(fieldId) {
    var controls = _fileControls.filter((fc) => fc.id === fieldId);
    if (controls) {
      controls.forEach((control) => {
        control.files = [];
      });
    }
  }

  function getFilesForControl(fieldId, nodeId) {
    var fileList = getFileControl(fieldId, nodeId);

    if (!fileList) return [];

    return fileList.files;
  }

  function isFileRequired(fieldId, nodeId) {
    var fileList = getFileControl(fieldId, nodeId);
    return fileList && fileList.isRequired;
  }

  function registerFileControl(fieldId, stepId, nodeId) {
    var found = lodashService.find(_fileControls, function (fc) {
      if (stepId) return fc.id === fieldId && fc.stepId === stepId;

      if (nodeId) return fc.id === fieldId && fc.nodeId === nodeId;
    });

    if (!found) {
      if (stepId)
        _fileControls.push({
          id: fieldId,
          stepId: stepId,
          files: [],
          isDirty: false
        });

      if (nodeId)
        _fileControls.push({
          id: fieldId,
          nodeId: nodeId,
          files: [],
          isDirty: false
        });
    }
  }

  function removeAllFileControls() {
    _fileControls = [];
  }

  function removeFile(file, fieldId, nodeId, field) {
    var fileList = getFileControl(fieldId, nodeId);
    if (!fileList) return $q.when();

    var index = lodashService.findIndex(fileList.files, function (f) {
      return f.id === file.id;
    });

    if (index !== -1) {
      fileList.files.splice(index, 1);
      fileList.isDirty = true;

      var schema_fileList = field;
      if (!schema_fileList && _form && _form.model && _form.model.schema) {
        schema_fileList = lodashService.find(
          _form.model.schema.fields,
          function (f) {
            return f.name == fieldId;
          }
        );
      }

      if (schema_fileList && schema_fileList.attachDocumentFileIds) {
        var schema_attachDocuments = schema_fileList.attachDocumentFileIds;
        var fileToRemove = lodashService.findIndex(
          schema_attachDocuments,
          function (f) {
            return f == file.id;
          }
        );

        if (fileToRemove !== -1) schema_attachDocuments.splice(fileToRemove, 1);
      }
    }

    return $q.when();
  }

  function storeForm(form) {
    _form = form;
  }

  function getFileControl(fieldId, nodeId) {
    return lodashService.find(_fileControls, function (l) {
      return l.id === fieldId && l.nodeId === nodeId;
    });
  }
}
